module.exports = __webpack_public_path__ + "static/media/success.d8d435aa.mp3";